// extracted by mini-css-extract-plugin
module.exports = {"root":"AddTileButton_root__14-Rd","rootSmall":"AddTileButton_rootSmall__25ucL"};